import {ACCESS_TOKEN, V1_API_URL_PREFIX} from '../Constants';
import {request} from "./ApiUtils";

export function communicationPlan() {
    return request({
        url: V1_API_URL_PREFIX + "/communication-plan",
        method: 'GET'
    });
}

export function communicationPlanRevision() {
    return request({
        url: V1_API_URL_PREFIX + "/communication-plan/latestRevision",
        method: 'GET'
    });
}

export function saveOrUpdateCommunicationPlan(record) {
    return request({
        url: V1_API_URL_PREFIX + "/communication-plan/update",
        method: 'POST',
        body: JSON.stringify(record)
    });
}

export function deleteCommunicationPlan(record) {
    const headers = new Headers({
        'Content-Type': 'application/json',
    });

    if (localStorage.getItem(ACCESS_TOKEN)) {
        headers.append('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN));
    }

    const defaults = {headers: headers};
    let options = Object.assign({}, defaults, {
        url: V1_API_URL_PREFIX + "/communication-plan/delete",
        method: 'DELETE',
        body: JSON.stringify(record)
    });

    return fetch(options.url, options)
        .then(response => {
                if (response.status !== 204) {
                    return Promise.reject();
                }
                return Promise.resolve();
            }
        );
}

export function addCommunicationPlanRevision(record) {
    return request({
        url: V1_API_URL_PREFIX + "/communication-plan/add/revision",
        method: 'POST',
        body: JSON.stringify(record)
    });
}

